<div class="app-basic-layout">
    <app-header></app-header>
<div class="w-100">
    <div class="m-auto panel_container">
        <router-outlet></router-outlet>
    </div>
</div>
<app-footer [customClass]="basicFooter?'footer_basic':''"></app-footer>
</div>
